import { useFormContext, useWatch } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';

import { axios } from '#api/axios';

import Title from 'src/refactor_components/common/Title';
import { DatePickerInput } from '#atoms';

import SearchInput from '../common/SearchInput';
import PdfUpload from 'src/refactor_shared/ui/PdfUpload';

import { parseDateToYearMonth } from 'src/refactor_shared/lib/parseYear';

const QualificationCertificate = () => {
  const methods = useFormContext();

  const namWatcher = useWatch({
    control: methods.control,
    name: 'name'
  });
  const issuerIdWatcher = useWatch({
    control: methods.control,
    name: 'issuerId'
  });

  const getAdminCertificate = async (name: string) => {
    const res = await axios.get<
      Array<{ name: string; issuer: string; issuerId: string }>
    >('/licenses/admin', {
      params: {
        name
      }
    });

    return res.data;
  };

  const { data } = useQuery({
    queryKey: ['license-list', namWatcher],
    queryFn: () => getAdminCertificate(namWatcher),
    enabled: !!namWatcher
  });

  const onClickItem = (index: number) => {
    if (!data) return;

    methods.setValue('name', data[index].name);
    methods.setValue('issuer', data[index].issuer);
    methods.setValue('issuerId', data[index].issuerId);
  };

  return (
    <>
      <div className="flex flex-col gap-8">
        <Title text="자격증명" essential={true} />
        <SearchInput
          registerName="name"
          data={data ? data : []}
          onClick={onClickItem}
        />
      </div>
      <div className="flex flex-col gap-8">
        <Title text="발행처" essential={true} />
        <input
          {...methods.register('issuer', {
            required: true
          })}
          className="focus:bg-white focus:text-black w-full bg-transparent border border-[#494949] p-10 text-16 rounded-[5px] h-53 placeholder:text-[#999]"
          placeholder="발행처를 입력해 주세요"
          disabled={issuerIdWatcher ? true : false}
        />
      </div>

      <div className="flex flex-col gap-8">
        <Title text="취득 연월" essential={true} />
        <DatePickerInput
          required
          title="취득 연월"
          onlyYearMonth
          onChange={date => {
            methods.setValue('gotAt', date.toISOString());
          }}
        >
          <div className="text-[#999] p-16 border border-solid border-[#494949] rounded-5">
            <div className="">
              {methods.watch('gotAt')
                ? parseDateToYearMonth(methods.getValues('gotAt'))
                : '취득 연월'}
            </div>
          </div>
        </DatePickerInput>
      </div>

      <PdfUpload registerName="images" titleText="증명자료 제출" />
    </>
  );
};

export default QualificationCertificate;
